import { Component, Input, OnInit } from '@angular/core';
import { LicenseService } from '../../../services/license.service';
import { EnvironmentService } from '../../../services/environment.service';
import { BaseTileComponent } from '../tile.component';
import {Observable} from 'rxjs/Observable';

@Component({
    selector: 'itpx-scorm-tile',
    templateUrl: './tile.component.html',
    styleUrls: ['./tile.component.css']
})

export class ScormTileComponent extends BaseTileComponent implements OnInit {
    @Input() deliverable: any;

    private images: string;
    private href: string = '#';

    constructor(
        private licenseService: LicenseService,
        private environmentService: EnvironmentService
    ) {
        super();
    }

    ngOnInit() {
        this.images = this.environmentService.config['server'].images;
        super.init(this.licenseService, this.deliverable, true);
    }

    complete(deliverable: any, createTarget: boolean) {
        if(!deliverable.disabled)
          this.href = '/#/app/' + deliverable.type + '/' + deliverable.assignmentId + '/' + deliverable.id;
        super.complete(deliverable, createTarget);
    }

    private getDeliverableProgress(): string {
        let report = this.deliverable.report;
        if (!report) {
            return null;
        }

        if (report.completed) {
            return 'completed';
        } else if (report.attempted) {
            return 'in progress';
        } else {
            return 'new';
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/core/components/content/scorm/tile.component.ts